import Isotope from 'isotope-layout';

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.isotope-grid');
  if (!grid) return;

  // ✅ Initialize Isotope but don’t touch positioning (layoutMode: 'fitRows' works with Tailwind grid)
  const iso = new Isotope(grid, {
    itemSelector: '.isotope-item',
    layoutMode: 'fitRows', // keeps it in grid-like structure
    percentPosition: true,
    transitionDuration: '0.4s'
  });

   // ✅ Filter buttons
   const filterButtons = document.querySelectorAll('.filter-button');

   filterButtons.forEach((btn) => {
     btn.addEventListener('click', () => {
       // Reset all buttons to inactive state
       filterButtons.forEach((b) => {
         b.classList.remove(
           'text-white',
           'bg-primary-400',
           'hover:bg-primary-400'
         );
         b.classList.add(
           'text-primary-400',
           'hover:bg-primary-50'
         );
       });
 
       // Set clicked button to active state
       btn.classList.remove('text-primary-400', 'hover:bg-primary-50');
       btn.classList.add('text-white', 'bg-primary-400', 'hover:bg-primary-400');
 
       // Filter grid
       const filterValue = btn.getAttribute('data-filter');
       iso.arrange({ filter: filterValue });
     });
   });


  const emptyMsg = document.getElementById('emptyMessage');

  // Update empty message visibility
  function toggleEmptyMessage() {
    if (iso.filteredItems.length === 0) {
      emptyMsg.classList.remove('hidden', 'opacity-0');
      emptyMsg.classList.add('block', 'opacity-100');
      emptyMsg.setAttribute('aria-hidden', 'false');
    } else {
      emptyMsg.classList.add('hidden');
      emptyMsg.classList.remove('block', 'opacity-100');
      emptyMsg.setAttribute('aria-hidden', 'true');
    }
  }

  // Handle filtering
  document.querySelectorAll('[data-filter]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const filterValue = btn.getAttribute('data-filter');
      iso.arrange({ filter: filterValue });
    });
  });

  // Watch for arrange completion
  iso.on('arrangeComplete', toggleEmptyMessage);

  // Initial check
  toggleEmptyMessage();
});
